import { Stack, SxProps, Typography, useTheme } from "@mui/material";
import { DialogSectionDark } from "./styled-components";

interface IDialogSection {
  title?: string;
  children: React.ReactNode;
  dark?: boolean;
  sx?: SxProps;
}

const DialogSection = ({ title, children, dark, sx }: IDialogSection) => {
  const theme = useTheme();
  return (
    <Stack spacing={2} sx={sx}>
      {title && (
        <Typography variant="textLg700" color="dsBase.v200">
          {title}
        </Typography>
      )}
      {dark ? <DialogSectionDark>{children}</DialogSectionDark> : children}
    </Stack>
  );
};

export default DialogSection;
